<!--
        The following <button /> element is only visible on small
    (fewer than 748px) screens. It's only purpose is to "close" the
    navigation menu on mobile.
-->
<button type="button" id="app-sidebar-escape" class="naked app-sidebar__escape" (click)="hideSidebarMenu()">
  <svg
    class="svg-icon"
    width="24"
    height="24"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 24 24"
  >
    <g transform="translate(0, 0)">
      <polygon
        fill="currentColor"
        points="16.95 8.464 15.536 7.05 12 10.586 8.464 7.05 7.05 8.464 10.586 12 7.05 15.536 8.464 16.95 12 13.414 15.536 16.95 16.95 15.536 13.414 12 16.95 8.464"
      />
    </g>
  </svg>
</button>
<!--
        The following <div /> element contains all of the "primary" items.
    The markup composition for item is important so each displays accurately.
    Icons are rendered as <svg />, however not necessary.
-->
<div class="app-sidebar__primary">
  <div class="app-sidebar__primary-id">
    <div class="app-sidebar__primary-id-labels">
      <p>{{ user?.Contact?.FirstName }} {{ user?.Contact?.LastName }}</p>
      <p>
        <em>{{ acct?.AccountName || 'Loading…' }}</em>
      </p>
    </div>
    @if (permissionsSvc.hasMultipleAccountAccessRoles()) {
    <button
      type="button"
      class="btn--oneok btn--oneok--white btn--oneok--icon app-sidebar__btn oneok-blue ph-no-capture"
      style="font-size: 0.985rem"
      data-tooltip="Switch Accounts"
      data-tooltip-dir="inline-end"
      [disabled]="$isLoading()"
      (click)="switchAccount()"
    >
      <span>{{ $isLoading() ? 'Loading Accounts' : 'Switch Account' }}</span> @if ($isLoading()) {
      <span class="spinner-border spinner-border-sm ms-2" id="loading-spinner" role="status"></span>
      }
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 24 24"
        width="24"
        height="24"
      >
        <g transform="translate(0, 0)">
          <path
            d="M0,8h4.219c0.85,0,1.662,0.362,2.229,0.993l1.361,1.512l1.345-1.495l-1.22-1.356 C6.989,6.604,5.635,6,4.219,6H0V8z"
          />
          <path
            d="M24,7l-5-4v3h-2.219c-1.416,0-2.771,0.604-3.716,1.655l-6.617,7.352C5.881,15.638,5.068,16,4.219,16H0v2 h4.219c1.416,0,2.771-0.604,3.716-1.655l6.617-7.352C15.119,8.362,15.932,8,16.781,8H19v3L24,7z"
          />
          <path
            d="M24,17l-5-4v3h-2.219c-0.85,0-1.662-0.362-2.229-0.993l-1.361-1.512l-1.345,1.495l1.22,1.355 c0.945,1.052,2.3,1.655,3.716,1.655H19v3L24,17z"
          />
        </g>
      </svg>
    </button>
    }
  </div>
  <ul class="app-sidebar__primary-items">
    <!--<li class="list-item--primary" routerLinkActive="list-item--primary active">
      <a [routerLink]="['/home', acct.AccountId]" class="list-item--primary__anchor" data-tooltip="Home" data-tooltip-dir="inline-end">
        <svg data-unique-ids="disabled" data-css-scoping="disabled" data-cache="disabled" class="svg-icon" width="24" height="24" fill="currentColor">
          <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 24 24">
            <g transform="translate(0, 0)"><path d="M23.633,10.226l-11-9a1,1,0,0,0-1.266,0l-11,9a1,1,0,0,0,1.266,1.548L3,10.656V22a1,1,0,0,0,1,1h6V17h4v6h6a1,1,0,0,0,1-1V10.656l1.367,1.118a1,1,0,1,0,1.266-1.548Z"></path></g>
          </svg>
        </svg>
        <p class="main fw--400">Home</p>
      </a>
    </li>
    -->
    @if (isNGGPTabVisible() && user?.HasAccountSelected) {
    <li
      #rla0="routerLinkActive"
      class="list-item--primary"
      routerLinkActive
      [routerLinkActiveOptions]="{ exact: true }"
      [class.active]="isValidSegmentPage(rla0.isActive, 'nggp')"
    >
      <a
        class="list-item--primary__anchor"
        data-tooltip="Natural Gas Gathering & Processing"
        data-tooltip-dir="inline-end"
        [attr.disabled]="!acct"
        [routerLink]="['/gathering-and-processing']"
      >
        <svg
          _ngcontent-trb-c110=""
          xmlns="http://www.w3.org/2000/svg"
          width="26"
          height="24"
          viewBox="0 0 26 24"
          fill="currentColor"
          class="svg-icon"
        >
          <path
            _ngcontent-trb-c110=""
            d="M26,24H0V22H1V7A2,2,0,0,1,3,5H4A1,1,0,0,1,5,4H6V1.5A1.5,1.5,0,0,1,7.5,0h11A1.5,1.5,0,0,1,20,1.5V4h1a1,1,0,0,1,1,1h1a2,2,0,0,1,2,2V22h1v2ZM16,7V22h7V7ZM7.5,1a.5.5,0,0,0-.5.5V4H8A1,1,0,0,1,9,5h1a2,2,0,0,1,2,2V22h2V7a2,2,0,0,1,2-2h1a1,1,0,0,1,1-1h1V1.5a.5.5,0,0,0-.5-.5ZM3,7V22h7V7Z"
          />
        </svg>
        <p class="main fw--400"><span>Natural Gas</span>Gathering & Processing</p>
      </a>
      <!-- prettier-ignore -->
      @if (isValidSegmentPage(rla0.isActive, 'nggp') && ['dashboard', 'documents', 'gathering & processing'].indexOf(storageSvc.currentPageSource.value!.toLowerCase()) < 0) {
      <span class="page--sub">
        <!-- prettier-ignore -->
        {{ storageSvc.currentPageSource.value!.slice( storageSvc.currentPageSource.value!.includes('NGGP ') ? storageSvc.currentPageSource.value!.indexOf('NGGP ') + 5 : 0 ) }}
      </span>
      }
    </li>
    }
    <!-- NGP dashboard  -->
    @if (isNGPTabVisible() && user?.HasAccountSelected) {
    <li
      #rla="routerLinkActive"
      class="list-item--primary"
      routerLinkActive
      [routerLinkActiveOptions]="{ exact: true }"
      [class.active]="isValidSegmentPage(rla.isActive, 'ngp')"
    >
      <a
        class="list-item--primary__anchor"
        data-tooltip="Natural Gas Intrastate Pipelines"
        data-tooltip-dir="inline-end"
        [attr.disabled]="!acct"
        [routerLink]="['/intrastate-pipelines']"
      >
        <svg
          _ngcontent-trb-c110=""
          xmlns="http://www.w3.org/2000/svg"
          width="26"
          height="24"
          viewBox="0 0 26 24"
          fill="currentColor"
          class="svg-icon"
        >
          <path
            _ngcontent-trb-c110=""
            d="M16,24H14a5.006,5.006,0,0,1-5-5V14H8V13h6v1H13v5a1.014,1.014,0,0,0,1,1h2a1.013,1.013,0,0,0,1-1V2H16V1h6V2H21V19A5.006,5.006,0,0,1,16,24ZM6,23H0V22H1V5A5.006,5.006,0,0,1,6,0H8a5.006,5.006,0,0,1,5,5v5h1v1H8V10H9V5A1.014,1.014,0,0,0,8,4H6A1.014,1.014,0,0,0,5,5V22H6v1Z"
          />
        </svg>
        <p class="main fw--400"><span>Natural Gas</span>Intrastate Pipelines</p>
      </a>
      <!-- prettier-ignore -->
      @if (isValidSegmentPage(rla.isActive, 'ngp') && ['ngpdashboard', 'intrastate pipelines'].indexOf(storageSvc.currentPageSource.value!.toLowerCase()) < 0) {
      <span class="page--sub">{{ storageSvc.currentPageSource.value }}</span>
      }
    </li>
    }
    <!-- END NGP dashboard  -->
    @if (isAdministrationTabVisible() && user?.HasAccountSelected) {
    <li class="list-item--primary" routerLinkActive="list-item--primary active">
      <a
        class="list-item--primary__anchor"
        data-tooltip="Administration"
        data-tooltip-dir="inline-end"
        [attr.disabled]="!acct"
        [routerLink]="['/admin']"
      >
        <svg
          data-src="svg/building.svg"
          data-unique-ids="disabled"
          data-css-scoping="disabled"
          data-cache="disabled"
          class="svg-icon"
          width="21"
          height="24"
          fill="currentColor"
        >
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
            <path
              d="M436,480H416V24A24,24,0,0,0,392,0H56A24,24,0,0,0,32,24V480H12A12,12,0,0,0,0,492v20H448V492A12,12,0,0,0,436,480ZM128,76a12,12,0,0,1,12-12h40a12,12,0,0,1,12,12v40a12,12,0,0,1-12,12H140a12,12,0,0,1-12-12Zm0,96a12,12,0,0,1,12-12h40a12,12,0,0,1,12,12v40a12,12,0,0,1-12,12H140a12,12,0,0,1-12-12Zm52,148H140a12,12,0,0,1-12-12V268a12,12,0,0,1,12-12h40a12,12,0,0,1,12,12v40A12,12,0,0,1,180,320Zm76,160H192V396a12,12,0,0,1,12-12h40a12,12,0,0,1,12,12Zm64-172a12,12,0,0,1-12,12H268a12,12,0,0,1-12-12V268a12,12,0,0,1,12-12h40a12,12,0,0,1,12,12Zm0-96a12,12,0,0,1-12,12H268a12,12,0,0,1-12-12V172a12,12,0,0,1,12-12h40a12,12,0,0,1,12,12Zm0-96a12,12,0,0,1-12,12H268a12,12,0,0,1-12-12V76a12,12,0,0,1,12-12h40a12,12,0,0,1,12,12Z"
            />
          </svg>
        </svg>
        <p class="main fw--400">Administration</p>
      </a>
    </li>
    }
  </ul>
</div>
<!--
    This <ul /> element contains more utility-based items:
        • Contact ID
        • Account-switcher (if applicable)
        • Personal profile link + Help Center link + Log out link
-->
<ul class="app-sidebar__utility">
  <li class="app-sidebar__utility-item" routerLinkActive="list-item--primary active">
    <a
      class="app-sidebar__utility-item__anchor oneok-blue"
      data-tooltip="View your profile"
      [attr.disabled]="!acct"
      [routerLink]="['/profile']"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 24 24"
        width="24"
        height="24"
      >
        <g transform="translate(0, 0)">
          <path
            d="M12,0C5.383,0,0,5.383,0,12s5.383,12,12,12s12-5.383,12-12S18.617,0,12,0z M8,10c0-2.209,1.844-4,4-4 s4,1.791,4,4v1c0,2.209-1.844,4-4,4s-4-1.791-4-4V10z M12,22c-2.433,0-4.665-0.876-6.401-2.326C6.438,18.091,8.083,17,10,17h4 c1.917,0,3.562,1.091,4.401,2.674C16.665,21.124,14.433,22,12,22z"
          />
        </g>
      </svg>
    </a>
  </li>
  <li class="app-sidebar__utility-item" routerLinkActive="list-item--primary active">
    <a
      class="app-sidebar__utility-item__anchor oneok-blue"
      data-tooltip="Visit the Help Center"
      data-tooltip-dir="inline-end"
      [attr.disabled]="!acct"
      [routerLink]="['/help']"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 24 24"
        height="24"
        width="24"
      >
        <g transform="translate(0, 0)">
          <path
            d="M12,0C5.383,0,0,5.383,0,12s5.383,12,12,12s12-5.383,12-12S18.617,0,12,0z M11.5,19 c-0.828,0-1.5-0.672-1.5-1.5s0.672-1.5,1.5-1.5s1.5,0.672,1.5,1.5S12.328,19,11.5,19z M15.811,10.127 c-0.309,0.495-0.896,1.051-1.762,1.669c-1.401,1.036-1.363,1.266-1.363,2.204h-2.457c0-0.733-0.016-1.296,0.38-1.981 c0.253-0.439,0.717-0.906,1.391-1.4c0.809-0.578,1.595-1.135,1.595-2.105c0-0.909-0.778-1.233-1.687-1.233 c-0.927,0-1.984,0.303-3.171,0.909l-1.011-2.03c2.157-1.209,5.561-1.756,7.422-0.241C16.514,7.032,16.522,8.989,15.811,10.127z"
          />
        </g>
      </svg>
    </a>
  </li>
  <li class="app-sidebar__utility-item">
    <a
      class="app-sidebar__utility-item__anchor oneok-blue"
      data-tooltip="Log out"
      data-tooltip-dir="inline-end"
      [attr.disabled]="!acct"
      (click)="onLogout()"
      (keydown.enter)="onLogout()"
      (keydown.space)="onLogout()"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 24 24"
        height="24"
        width="24"
      >
        <g transform="translate(0, 0)">
          <path
            d="M8,24a.988.988,0,0,1-.581-.187l-7-5A1,1,0,0,1,0,18V1A1,1,0,0,1,1,0c.388,0,1.185.624,1.316.718L8.582,5.2A1,1,0,0,1,9,6.016V23a1,1,0,0,1-.542.89A1.019,1.019,0,0,1,8,24Z"
          />
          <path d="M11,13v6h3a1,1,0,0,0,1-1V13Z" />
          <path d="M11,6.016V7h4V1a1,1,0,0,0-1-1H4.751l5,3.576A3.013,3.013,0,0,1,11,6.016Z" />
          <polygon points="24 10 18 5 18 9 11 9 11 11 18 11 18 15 24 10" />
        </g>
      </svg>
    </a>
  </li>
</ul>
